export default () => import.meta.env.DEV ? undefined : 'augmento.com'
